import { useAnalytics } from './index';

const analytics = useAnalytics();

export const {
  trackEvent,
  trackEventImmediately,
  useClickTracker,
  useImmediateClickTracker,
  useImmediateViewTracker,
  useViewTracker,
} = analytics;
